import { useParams } from 'next/navigation';
import type { CountryCode } from '@/lib/country';

export function useCountry(): CountryCode {
  const params = useParams();
  return (params?.country as CountryCode) || 'au';
}
